import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import ShareSpace from "models/interfaces/share-spaces/share-space";
import ShareSpaceItemRecord from "./share-space-item-record";
import ShareSpaceRecipientRecord from "./share-space-recipient-record";
import moment from "moment";

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const defaultValues: ShareSpace =
    RecordUtils.auditableDefaultValuesFactory<ShareSpace>({
        title: "",
        description: "",
        sentOn: undefined,
        expiresOn: undefined,
        shareSpaceItems: [],
        shareSpaceRecipients: [],
    });

// #endregion Constants

export default class ShareSpaceRecord
    extends Record(defaultValues)
    implements ShareSpace
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: ShareSpace) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.shareSpaceItems != null) {
            params.shareSpaceItems = params.shareSpaceItems.map((item) =>
                RecordUtils.ensureRecord(item, ShareSpaceItemRecord)
            );
        }

        if (params.shareSpaceRecipients != null) {
            params.shareSpaceRecipients = params.shareSpaceRecipients.map(
                (recipient) =>
                    RecordUtils.ensureRecord(
                        recipient,
                        ShareSpaceRecipientRecord
                    )
            );
        }

        super(params);
    }

    // #endregion Constructor

    // #region Public Methods
    public isExpired(): boolean {
        return moment().isAfter(this.expiresOn);
    }
    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<ShareSpace>} values
     */
    public with(values: Partial<ShareSpace>): ShareSpaceRecord {
        return new ShareSpaceRecord(Object.assign(this.toJS(), values));
    }

    // #endredion Public Methods
}
